export default ($t) => ({
  title: "SendSmsToTeamLeadersWhenTeamCreated",
  type: "object",
  properties: {
    value: {
      title: "Active",
      type: "boolean",
    },
    sms_template: {
      hidden: true,
      title: $t(
        "edit_campaign.schema_send_sms_to_team_leaders_when_team_created_sms_template_id",
        "SMS template ID"
      ),
      type: "number",
      default: 0,
      description: $t(
        "edit_campaign.schema_send_sms_to_team_leaders_when_team_created_sms_template_id_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
    },
    on_team_import: {
      title: $t(
        "edit_campaign.schema_send_sms_to_team_leaders_when_team_created_on_team_import_title",
        "Send SMS on team import"
      ),
      type: "boolean",
      default: false,
      description: $t(
        "edit_campaign.schema_send_sms_to_team_leaders_when_team_created_on_team_import_description",
        { returnEmptyOnMissing: true }
      ),
    },
    on_team_created_from_dashboard: {
      title: $t(
        "edit_campaign.schema_send_sms_to_team_leaders_when_team_created_on_team_created_from_dashboard_title",
        "Send SMS when team is created from dashboard"
      ),
      type: "boolean",
      default: false,
      description: $t(
        "edit_campaign.schema_send_sms_to_team_leaders_when_team_created_on_team_created_from_dashboard_description",
        { returnEmptyOnMissing: true }
      ),
    },
    on_team_created_from_campaign_page: {
      title: $t(
        "edit_campaign.schema_send_sms_to_team_leaders_when_team_created_on_team_created_from_campaign_page_title",
        "Send SMS when team is created from campaign page"
      ),
      type: "boolean",
      default: false,
      description: $t(
        "edit_campaign.schema_send_sms_to_team_leaders_when_team_created_on_team_created_from_campaign_page_description",
        { returnEmptyOnMissing: true }
      ),
    },
    on_team_nomination: {
      title: $t(
        "edit_campaign.schema_send_sms_to_team_leaders_when_team_created_on_team_nomination_title",
        "Send SMS on team nomination"
      ),
      type: "boolean",
      default: false,
      description: $t(
        "edit_campaign.schema_send_sms_to_team_leaders_when_team_created_on_team_nomination_description",
        { returnEmptyOnMissing: true }
      ),
    },
  },
});
